import React from 'react';
import { Button } from './ui/Button';
import { ArrowRight, Star } from 'lucide-react';
export function Hero() {
  return <section className="relative overflow-hidden bg-[#FAF8F5] pt-12 pb-16 md:pt-20 md:pb-24" data-id="element-152">
      <div className="container mx-auto px-4 md:px-6" data-id="element-153">
        <div className="flex flex-col md:flex-row items-center gap-12 md:gap-16" data-id="element-154">
          {/* Text Content */}
          <div className="flex-1 max-w-2xl" data-id="element-155">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-[#E8F0E6] text-[#6B8E6B] text-sm font-medium mb-6" data-id="element-156">
              <Star className="w-4 h-4 fill-current" data-id="element-157" />
              <span data-id="element-158">Para mamás en USA con niños sensibles</span>
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-[#44403C] leading-tight mb-6" data-id="element-159">
              Limpias… y aún así lo estás{' '}
              <span className="text-[#C97D60]" data-id="element-160">empeorando</span>.
            </h1>

            <p className="text-xl text-[#57534E] mb-8 leading-relaxed" data-id="element-161">
              No es que estés fallando como mamá. Es que estás intentando ganar
              un juego que está diseñado para confundirte. Descubre cómo romper
              el ciclo en 14 días.
            </p>

            <div className="flex flex-col sm:flex-row gap-4" data-id="element-162">
              <Button size="lg" onClick={() => document.getElementById('pricing')?.scrollIntoView({
              behavior: 'smooth'
            })} data-id="element-163">
                Quiero el Plan de 14 Días
                <ArrowRight className="ml-2 w-5 h-5" data-id="element-164" />
              </Button>
              <p className="text-sm text-[#78716C] mt-3 sm:mt-0 sm:self-center italic" data-id="element-165">
                *Checklists bilingües incluidos
              </p>
            </div>
          </div>

          {/* Image */}
          <div className="flex-1 w-full max-w-md md:max-w-full relative" data-id="element-166">
            <div className="absolute inset-0 bg-[#C97D60] rounded-3xl rotate-3 opacity-10 transform scale-105" data-id="element-167"></div>
            <img src="https://cdn.magicpatterns.com/uploads/fg9iYd4SihiwjHsqmFcrZJ/heylloyd-image-1769486680554.png" alt="Mamá leyendo la guía Rutina Low-Tox en una cocina cálida" className="relative rounded-3xl shadow-xl w-full object-cover aspect-[4/5] md:aspect-square" data-id="element-168" />
          </div>
        </div>
      </div>
    </section>;
}